import './lib/polyfills';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from "react-router";
import { initAnalytics } from './lib/analytics';

import App from './App'

const root = createRoot(document.getElementById('root')!)


// Initialize analytics when the document is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  // Wait a short time to ensure the analytics script is loaded
  setTimeout(() => {
    if (window.telegramAnalytics) {
      initAnalytics();
    } else {
      // If not loaded yet, wait for it
      const analyticsScript = document.querySelector('script[src*="tganalytics.xyz"]');
      if (analyticsScript) {
        analyticsScript.addEventListener('load', initAnalytics);
      }
    }
  }, 100);
});

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
